import styled from "@emotion/styled"

export const StyledAiReview = styled.div`
  .page-surface {
    padding: 28px;
    background: var(--cms-content-bg);
    border-radius: 16px;
    border: 1px solid var(--cms-border);
  }

  .filters-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 28px;
    flex-wrap: wrap;
  }

  .filters {
    display: flex;
    gap: 12px;
    align-items: center;
    flex-wrap: wrap;
  }

  .filter-select {
    padding: 10px 14px;
    border: 1px solid var(--cms-border);
    border-radius: 10px;
    background: var(--cms-surface-secondary);
    color: var(--cms-text-primary);
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    min-width: 140px;

    &:hover {
      border-color: var(--primary-color-light);
      box-shadow: 0 2px 8px rgba(132, 70, 173, 0.1);
    }

    &:focus {
      outline: none;
      border-color: var(--primary-color);
      box-shadow: 0 0 0 3px rgba(132, 70, 173, 0.1);
    }
  }

  .filter-label {
    font-size: 13px;
    font-weight: 600;
    color: var(--cms-text-secondary);
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .batch-actions {
    display: flex;
    gap: 10px;
    align-items: center;

    button {
      padding: 10px 16px;
      border: none;
      border-radius: 10px;
      font-weight: 600;
      font-size: 14px;
      cursor: pointer;
      transition: all 0.2s ease;
      min-height: 38px;

      &.btn-approve {
        background: linear-gradient(135deg, #10b981 0%, #059669 100%);
        color: white;
        box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 16px rgba(16, 185, 129, 0.4);
        }

        &:active {
          transform: translateY(0);
        }
      }

      &.btn-reject {
        background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
        color: white;
        box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 16px rgba(239, 68, 68, 0.4);
        }

        &:active {
          transform: translateY(0);
        }
      }

      &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
        transform: none;
      }
    }

    .selected-count {
      color: var(--cms-text-secondary);
      font-size: 13px;
      font-weight: 500;
      padding: 0 8px;
    }
  }

  .table-wrapper {
    overflow: hidden;
    border-radius: 12px;
    border: 1px solid var(--cms-border);
    background: var(--cms-surface-secondary);
    box-shadow: 0 4px 16px rgba(15, 23, 42, 0.08);
  }

  .batch-table {
    width: 100%;
    border-collapse: collapse;

    th,
    td {
      padding: 14px 16px;
      text-align: left;
      vertical-align: middle;
    }

    thead {
      background: var(--cms-table-head-bg);
      border-bottom: 2px solid var(--cms-border);

      th {
        font-weight: 700;
        font-size: 13px;
        color: var(--cms-text-primary);
        text-transform: uppercase;
        letter-spacing: 0.5px;
      }
    }

    tbody tr {
      border-bottom: 1px solid var(--cms-border);
      transition: background-color 0.15s ease;

      &:hover {
        background-color: rgba(132, 70, 173, 0.04);
      }

      &:last-child {
        border-bottom: none;
      }
    }

    td {
      font-size: 14px;
      color: var(--cms-text-primary);

      &.cell-checkbox {
        width: 44px;
        padding: 14px 12px;
      }

      &.cell-id {
        font-weight: 600;
        color: var(--primary-color);
        font-family: ui-monospace, monospace;
      }

      &.cell-tool {
        font-weight: 500;
        background: linear-gradient(135deg, rgba(132, 70, 173, 0.06) 0%, rgba(168, 85, 247, 0.04) 100%);
        border-radius: 6px;
        padding: 10px 12px;
        display: inline-block;
        color: var(--cms-link-color);
      }

      &.cell-summary {
        max-width: 400px;
        word-break: break-word;
        color: var(--cms-text-primary);
      }
    }
  }

  .status-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 6px 12px;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 600;
    min-width: 90px;
    text-align: center;

    &.status-pending {
      background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
      color: white;
      box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
    }

    &.status-approved {
      background: linear-gradient(135deg, #10b981 0%, #059669 100%);
      color: white;
      box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3);
    }

    &.status-executed {
      background: linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%);
      color: white;
      box-shadow: 0 2px 8px rgba(139, 92, 246, 0.3);
    }

    &.status-rejected {
      background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
      color: white;
      box-shadow: 0 2px 8px rgba(239, 68, 68, 0.3);
    }

    &.status-failed {
      background: linear-gradient(135deg, #f97316 0%, #ea580c 100%);
      color: white;
      box-shadow: 0 2px 8px rgba(249, 115, 22, 0.3);
    }
  }

  .risk-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 6px 12px;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 600;
    min-width: 80px;
    text-align: center;

    &.risk-normal {
      background: linear-gradient(135deg, rgba(16, 185, 129, 0.12) 0%, rgba(5, 150, 105, 0.08) 100%);
      color: #047857;
      border: 1px solid rgba(16, 185, 129, 0.3);
    }

    &.risk-high {
      background: linear-gradient(135deg, rgba(239, 68, 68, 0.12) 0%, rgba(220, 38, 38, 0.08) 100%);
      color: #991b1b;
      border: 1px solid rgba(239, 68, 68, 0.3);
    }
  }

  .row-actions {
    display: flex;
    gap: 8px;
    align-items: center;

    button {
      padding: 7px 14px;
      border: 1px solid var(--cms-border);
      border-radius: 8px;
      background: var(--cms-surface-secondary);
      color: var(--primary-color);
      font-size: 13px;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.2s ease;
      white-space: nowrap;

      &:hover {
        background: linear-gradient(135deg, rgba(132, 70, 173, 0.08) 0%, rgba(168, 85, 247, 0.04) 100%);
        border-color: var(--primary-color);
        box-shadow: 0 2px 8px rgba(132, 70, 173, 0.15);
      }

      &.btn-approve {
        color: #10b981;
        border-color: rgba(16, 185, 129, 0.3);

        &:hover {
          background: linear-gradient(135deg, rgba(16, 185, 129, 0.08) 0%, rgba(5, 150, 105, 0.04) 100%);
          border-color: #10b981;
        }
      }

      &.btn-reject {
        color: #ef4444;
        border-color: rgba(239, 68, 68, 0.3);

        &:hover {
          background: linear-gradient(135deg, rgba(239, 68, 68, 0.08) 0%, rgba(220, 38, 38, 0.04) 100%);
          border-color: #ef4444;
        }
      }

      &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }
    }
  }

  .empty-state {
    padding: 60px 24px;
    text-align: center;
    color: var(--cms-text-secondary);

    .empty-icon {
      font-size: 48px;
      margin-bottom: 16px;
      opacity: 0.5;
    }

    .empty-title {
      font-size: 18px;
      font-weight: 600;
      color: var(--cms-text-primary);
      margin-bottom: 8px;
    }

    .empty-desc {
      font-size: 14px;
      color: var(--cms-text-secondary);
    }
  }

  .diff-block {
    margin: 0;
    background: var(--cms-surface-muted);
    border: 1px solid var(--cms-border);
    border-radius: 10px;
    padding: 14px;
    max-height: 380px;
    overflow: auto;
    font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
    font-size: 13px;
    white-space: pre-wrap;
    word-break: break-word;
    line-height: 1.6;
    color: var(--cms-text-primary);

    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(132, 70, 173, 0.3);
      border-radius: 4px;

      &:hover {
        background: rgba(132, 70, 173, 0.5);
      }
    }
  }

  input[type="checkbox"] {
    width: 18px;
    height: 18px;
    cursor: pointer;
    accent-color: var(--primary-color);

    &:hover {
      accent-color: var(--primary-color-light);
    }
  }

  [data-cms-theme="dark"] & {
    .risk-badge.risk-normal {
      color: #6ee7b7 !important;
      background: rgba(16, 185, 129, 0.18);
    }

    .risk-badge.risk-high {
      color: #fca5a5 !important;
      background: rgba(239, 68, 68, 0.18);
    }
  }

  @media (max-width: 1024px) {
    .filters-container {
      flex-direction: column;
      align-items: flex-start;
    }

    .batch-actions {
      width: 100%;
      flex-direction: column;

      button {
        width: 100%;
      }
    }

    .table-wrapper {
      overflow-x: auto;
    }

    .batch-table {
      min-width: 900px;
    }
  }
`
